import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary, { initGlobalErrorHandlers } from './components/common/ErrorBoundary';
import { shouldHydrate } from './utils/hydration';
import { initSentryWhenIdle } from './utils/sentryLazy';

// react-snap nutzt Puppeteer mit User-Agent "ReactSnap" beim Build-Zeit-Prerender.
// Sentry und globale Error-Handler dort nicht initialisieren, sonst werden Build-Artefakte
// als echte Errors geloggt.
const isPrerender =
  typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

if (!isPrerender) {
  // Sentry (~82 KB unkomprimiert, rund ein Achtel des Haupt-Bundles) wird NICHT
  // statisch importiert. Auf den öffentlichen Landingpages — dem einzigen, was
  // die meisten Besucher je sehen — verzögerte es sonst den First Paint, ohne
  // vor dem Rendern irgendetwas beizutragen. Stattdessen: Laden im Idle nach dem
  // ersten Render. Fehler davor gehen nicht verloren, sie werden gepuffert und
  // nachgespielt (utils/sentryLazy.js).
  initGlobalErrorHandlers();
  initSentryWhenIdle();
}

// react-snap stempelt beim Prerender den Pfad in die HTML, damit wir zur Laufzeit
// erkennen, ob das ausgelieferte Markup wirklich zu dieser Route gehört. Für nicht
// prerenderte Routen liefert der SPA-Fallback sonst die Startseiten-HTML aus. Siehe
// utils/hydration.js. (Läuft nur im Prerender-Kontext, zur Laufzeit ein No-Op.)
window.snapSaveState = () => ({
  __PRERENDERED_PATH__: window.location.pathname,
});

const rootElement = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

const canHydrate = shouldHydrate({
  hasChildNodes: rootElement.hasChildNodes(),
  prerenderedPath: window.__PRERENDERED_PATH__,
  currentPath: window.location.pathname,
});

if (canHydrate) {
  // Markup von react-snap passt zur Route → hydrieren.
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  // Kein passendes Markup (z. B. SPA-Fallback mit Startseiten-HTML auf einer
  // nicht prerenderten Route): veraltetes Markup entfernen, sonst würde React
  // versuchen es zu hydrieren und mit Fehler #423 neu rendern.
  if (rootElement.hasChildNodes()) {
    rootElement.innerHTML = '';
  }
  ReactDOM.createRoot(rootElement).render(tree);
}